import { readNullableString, readRecord, readString } from '@/lib/readers';

export interface Organization {
  organizationId: string;
  name: string;
  logoObject: string | null;
  smallLogoObject: string | null;
  primaryColor: string;
  secondaryColor: string;
  hasSingleBrand: boolean;
}

/** Returns one organization, or null when it has no organization id. */
export function parseOrganization(response: unknown): Organization | null {
  const raw = readRecord(response);
  const organizationId = readString(raw.organization_id);
  if (!organizationId) return null;
  return {
    organizationId,
    name: readString(raw.name),
    logoObject: readNullableString(raw.logo_object),
    smallLogoObject: readNullableString(raw.small_logo_object),
    primaryColor: readString(raw.primary_color),
    secondaryColor: readString(raw.secondary_color),
    hasSingleBrand: raw.has_single_brand === true,
  };
}

/** The fields of the branding document. The name is on the organization itself. */
export type Branding = Pick<Organization, 'logoObject' | 'smallLogoObject' | 'primaryColor' | 'secondaryColor'>;

/** Returns the branding document of one organization. A missing field falls back to empty. */
export function parseBranding(raw: Record<string, unknown>): Branding {
  return {
    logoObject: readNullableString(raw.logo_object),
    smallLogoObject: readNullableString(raw.small_logo_object),
    primaryColor: readString(raw.primary_color),
    secondaryColor: readString(raw.secondary_color),
  };
}
